import { createSelector } from 'reselect';

import getElectCertificatesSelector from './getElectCertificatesSelector';
import getElectDecoratedLocationsSelector from './getElectDecoratedLocationsSelector';

export default createSelector(
  [getElectCertificatesSelector, getElectDecoratedLocationsSelector],
  (certificates, locations) => {
    return certificates.map((certificate) => {
      const decoratedLocations = locations
        .filter((location) => {
          return location.attachedConsumptionData.some((consumptionData) => {
            return consumptionData.certificates.some((attachment) => attachment.certificate_id === certificate.id);
          });
        })
        .map((location) => {
          // Add together location.attachedConsumptionData[].certificates[].applied_energy_kwh
          const totalAppliedKwh = location.attachedConsumptionData.reduce((sum, consumptionData) => {
            const attachment = consumptionData.certificates.find((att) => att.certificate_id === certificate.id);
            if (attachment) {
              return sum + (attachment.applied_energy_kwh || 0);
            }
            return sum;
          }, 0);

          return {
            ...location,
            certificate_kwh: totalAppliedKwh,
          };
        });

      return {
        ...certificate,
        attachedLocations: decoratedLocations,
      };
    });
  },
);
